import { type ReactNode } from 'react';

import { Box, IconButton, Stack } from '@mui/material';

import { Icon } from '@/components/atoms/Icon/Icon';

export interface SideDrawerProps {
  open: boolean;
  onClose: () => void;
  header: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}

const SideDrawer = ({
  open,
  onClose,
  header,
  footer,
  children,
}: SideDrawerProps) => (
  <Box
    aria-hidden={!open}
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 20,
      pointerEvents: open ? 'auto' : 'none',
    }}
  >
    <Box
      onClick={onClose}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: 'custom.charcoal',
        opacity: open ? 0.4 : 0,
        transition: 'opacity 200ms ease',
      }}
    />

    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        width: 440,
        maxWidth: '90%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
        borderLeft: 1,
        borderColor: 'divider',
        transform: open ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 220ms ease',
      }}
    >
      <Box
        sx={{
          p: 4,
          bgcolor: 'background.paper',
        }}
      >
        <Stack
          direction='row'
          spacing={2}
          sx={{
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <Box
            sx={{
              minWidth: 0,
              flex: 1,
            }}
          >
            {header}
          </Box>
          <IconButton aria-label='close' onClick={onClose}>
            <Icon icon='xmark' fontSize={18} />
          </IconButton>
        </Stack>
      </Box>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          p: 4,
        }}
      >
        {children}
      </Box>

      {footer && (
        <Box
          sx={{
            p: 4,
            pt: 0,
          }}
        >
          {footer}
        </Box>
      )}
    </Box>
  </Box>
);

SideDrawer.displayName = 'SideDrawer';
export default SideDrawer;
